import React from 'react';
import Navbar from '../Navbar';
import Services from '../Services';
import Footer from '../Footer';

const Service = () => {
  return (
    <>
       <Navbar />
       <Services />
       <Footer />  
    </>
  )
}

export default Service;
